import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NG_Modal } from '../../bootstrap/modal/modal';
import { UserInfo } from '../../user-info/user-info';

@Component({
  selector: 'app-mcx-header',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, CommonModule, UserInfo, NG_Modal],
  templateUrl: './mcx-header.html',
  styleUrl: './mcx-header.scss',
changeDetection: ChangeDetectionStrategy.OnPush
})
export class MCXHeader {

	menuOpen: boolean = false;

	constructor( public router: Router ) { }
}
